import { render } from "./employee-form.vue?vue&type=template&id=2f16ed89&scoped=true"
import script from "./employee-form.vue?vue&type=script&lang=js"
export * from "./employee-form.vue?vue&type=script&lang=js"

import "./employee-form.vue?vue&type=style&index=0&id=2f16ed89&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f16ed89"]])

export default __exports__